// Экран 3 из ТЗ раздел 3.3: моя подписка (тариф, статус, дата окончания, устройства).
// Устройства показаны здесь же, а не только на отдельном экране 4 — тот же ответ API их уже
// содержит (app/schemas/subscription.py::SubscriptionOut.devices), нет смысла делать второй запрос
// только чтобы физически разнести их по разным компонентам.
import { useTranslation } from "react-i18next";

import { useSubscription } from "../hooks/useSubscription";

const STATUS_KEYS = {
  active: "status_active",
  expiring: "status_expiring",
  expired: "status_expired",
  cancelled: "status_cancelled",
} as const;

export function MySubscriptionScreen() {
  const { t, i18n } = useTranslation();
  const { subscription, loading, error } = useSubscription();
  // toLocaleDateString() без аргумента locale берёт локаль окружения (в Telegram WebView — не
  // обязательно совпадает с языком интерфейса бота), из-за чего дата рендерилась как "26/08/2026"
  // вместо привычного "26.08.2026" — найдено живым тестированием 2026-08-20. Явно привязываем к
  // текущему языку i18n (ru/en), а не к окружению.
  const dateLocale = i18n.language === "en" ? "en-US" : "ru-RU";

  return (
    <div>
      <h1>{t("subscription_title")}</h1>
      {error && <p role="alert">{t("subscription_error")}</p>}
      {!error && loading && <p>{t("loading")}</p>}
      {!error && !loading && subscription === null && <p>{t("subscription_none")}</p>}
      {subscription && (
        <div>
          <p>
            {t("subscription_plan")}: <strong>{subscription.plan.title}</strong>
          </p>
          <p>
            {t("subscription_status")}: {t(STATUS_KEYS[subscription.status])}
          </p>
          <p>
            {t("subscription_expires_at")}:{" "}
            {new Date(subscription.expires_at).toLocaleDateString(dateLocale)}
          </p>
          <h2>{t("nav_devices")}</h2>
          {subscription.devices.length === 0 && <p>{t("devices_empty")}</p>}
          {subscription.devices.length > 0 && (
            <ul>
              {subscription.devices.map((device) => (
                <li key={device.id}>
                  {device.name}
                  {device.os ? ` (${device.os})` : ""}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
